import { render } from "./Rtpi.vue?vue&type=template&id=1e10f962&scoped=true&lang=pug"
import script from "./Rtpi.vue?vue&type=script&lang=ts"
export * from "./Rtpi.vue?vue&type=script&lang=ts"

import "./Rtpi.vue?vue&type=style&index=0&id=1e10f962&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1e10f962"

export default script